<template>
  <div>
    <form @submit.prevent="buscarPedido">
      <div class="row m-1 mb-3 testesSPi">
        <div class="col-8">
          <fccInput type="number" extraClasses="inputLabel" v-model="numeroPedido" required
            >Número Pedido</fccInput
          >
        </div>
        <div class="col-4">
          <fccButton tipo="submit">Buscar</fccButton>
          <fccButton tipo="button" class="ml-1" @click="limparPedido" v-if="insc != null"
            >Limpar</fccButton
          >
        </div>
      </div>
    </form>
    <b-card tag="article" class="shadow m-1" v-if="mostraPedido">
      <b-card-body>
        <div class="text-h6 text-subtitleNovo">
          {{ insc.instituicao }}
        </div>
        <div class="text-subtitle1Novo">{{ insc.concurso }}</div>
        <div><strong>Núm. Pedido:</strong> {{ insc.numeropedido }}</div>
        <div><strong>Data Inscrição:</strong> {{ insc.datainscricao }}</div>
        <template v-for="(lista, indexx) in insc.listacampo">
          <div
            :key="lista.idcampo"
            v-if="lista.listacampopredefinido != null && lista.listacampopredefinido.length"
            class="firstLetter"
          >
            <strong>{{ lista.nmcampo }} </strong>
            <span v-for="campo in lista.listacampopredefinido" :key="campo.idcampovalor"
              >{{ campo.descricao }} <br
            /></span>
          </div>
          <div :key="indexx" v-else>
            <strong>{{ lista.nmcampo }}</strong> {{ lista.valor }}
          </div>
        </template>
        <div v-if="insc.tratamentoinscricao != null" class="mt-3">
          <b-alert variant="dark" show style="font-size: 13px"
            >{{ insc.tratamentoinscricao }}
          </b-alert>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      numeroPedido: '',
      mostraPedido: false,
      insc: null
    }
  },
  methods: {
    limparPedido() {
      this.mostraPedido = false
      this.insc = null
      this.numeroPedido = ''
    },
    buscarPedido() {
      this.mostraPedido = false
      this.insc = null
      const historico = this.controlePage.idsituacao >= 6
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlConcursos +
            'Candidato/ListarInscricoesNumeroPedido/' +
            this.numeroPedido +
            '?teste=true&historico=' +
            historico,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.mostraPedido = true
            this.insc = response.data[0]
          } else {
            this.callAlert('Nenhum pedido encontrado', '', 'error', 'error')
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted() {
    this.limparPedido()
  },
  props: {
    controlePage: Object
  }
}
</script>
<style scoped>
.firstLetter:first-letter {
  text-transform: capitalize;
}
</style>